import { Box, ColorOptions, Loader, Spacer, TextNew as Text } from '@jfs/ui-new'
import { SodexoIcon } from '../../assets/images/svg/Sodexo'
import { Button } from '../../comps/Button'
import { convertHexToRGBA, isIFrame } from '../../utils'
import { staticStrings } from '../../utils/string'
import Pluxee from '../../assets/images/svg/Pluxee'

const FoodCardProcessing = ({ styles, theme, isLoading }: any) => {
  const handlePayment = () => {
    if (window.currentChild) {
      window.currentChild.focus()
    }
  }

  return (
    <>
      <Box {...styles.leftContainer}>
        <Box {...styles.cardIconContainer}>
          <Pluxee width={40} height={40} />
        </Box>
        <Spacer direction={'horizontal'} size={'SMALL'} />
        <Box width={'95%'}>
          <Text color={theme?.bodyTextColor as ColorOptions} fontSize={14} fontWeight="700">
            {'Pluxee | Sodexo'}
          </Text>
          <Text fontSize={12} color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions} fontWeight="700">
            {staticStrings.sodexoPayUsing}
          </Text>
        </Box>
      </Box>
      <Spacer direction="vertical" size={24} />
      {isLoading && <Loader type={'large'} color={theme?.brandColor as ColorOptions} />}
      <Spacer direction="vertical" size={18} />
      <Text
        title="Please wait..."
        fontSize={12}
        fontWeight="500"
        color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
      />
      <Text
        title="We are processing your payment with Pluxee,"
        fontSize={12}
        fontWeight="500"
        color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
      />
      <Text
        title="This might take few moment..."
        fontSize={12}
        fontWeight="500"
        color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
      />

      {isIFrame() && (
        <Box width="100%" paddingVertical={16} paddingHorizontal={32}>
          <Button
            title="Go Back To Payment"
            isFull={true}
            testID="backToPaymentTest"
            type="secondary"
            onPress={handlePayment}
          />
        </Box>
      )}
    </>
  )
}

export { FoodCardProcessing }
